import React, { useEffect, useRef, useState } from "react";

import BREAKDOWN from "../../assets/icons/HomeAssistance/BreakdownsShortCircuits.png";
import ONCALLSUPPORT from "../../assets/icons/AutoAssistance/OnCallSupport.png";
import COVEROLDAPPLIANCE from "../../assets/icons/HomeAssistance/CoversOldAppliances.png";
import CUSTOMIZABLEPLAN from "../../assets/icons/HomeAssistance/CustomizablePlans.png";
import VERIFIEDTECHNICIANS from "../../assets/icons/HomeAssistance/VerifiedTechnicians.png";
import DOORSTEPSERVICES from "../../assets/icons/HomeAssistance/DoorstepService.png";

const HOME_SERVICE_LIST = [
  {
    icon: BREAKDOWN,
    title: "Fire Breakout protection ",
    descp: "It covers appliances damaged in fire accident.",
  },
  {
    icon: ONCALLSUPPORT,
    title: "24×7 Emergency Support",
    descp: "Support for breakdowns, short circuits, and more.",
  },
  {
    icon: COVEROLDAPPLIANCE,
    title: "Covers Old Appliances ",
    descp: "Extended life of devices up to 10 years old.",
  },
  {
    icon: CUSTOMIZABLEPLAN,
    title: "Customizable Plans ",
    descp: "Various subscription-based year-round assurance.",
  },
  {
    icon: VERIFIEDTECHNICIANS,
    title: "Verified Technicians ",
    descp: "Professional Technicians and certified experts only.",
  },
  {
    icon: DOORSTEPSERVICES,
    title: "Doorstep service",
    descp:
      "Convenient doorstep service delivering expert solutions right to your home and save time.",
  },
];

const WhyHomeAssistance = () => {
  const [slidesToShow, setSlidesToShow] = useState(3);
  const [index, setIndex] = useState(slidesToShow); // The "real" index in the list
  const [transitionEnabled, setTransitionEnabled] = useState(true);
  const sliderRef = useRef(null);
  const autoplayRef = useRef(null);

  // Prepare clones for infinite scroll (clone ending + beginning)
  // E.g. [last3, ...items..., first3]
  const getClonedSlides = () => {
    const arr = HOME_SERVICE_LIST;
    if (slidesToShow > arr.length) return [...arr];
    const startClones = arr.slice(-slidesToShow);
    const endClones = arr.slice(0, slidesToShow);
    return [...startClones, ...arr, ...endClones];
  };

  const [clonedSlides, setClonedSlides] = useState(getClonedSlides());

  // Handle resize for responsiveness
  useEffect(() => {
    const updateSlides = () => {
      if (window.innerWidth <= 600) {
        setSlidesToShow(1);
      } else if (window.innerWidth <= 960) {
        setSlidesToShow(2);
      } else {
        setSlidesToShow(3);
      }
    };
    updateSlides();
    window.addEventListener("resize", updateSlides);
    return () => window.removeEventListener("resize", updateSlides);
  }, []);

  // When slidesToShow changes, reset everything
  useEffect(() => {
    // Need to rebuild clones and go to "first real slide"
    setClonedSlides(getClonedSlides());
    setIndex(slidesToShow); // real first slide is at slidesToShow
    setTransitionEnabled(false);
    // eslint-disable-next-line
  }, [slidesToShow]);

  // Next slide (move by one) for infinite
  const nextSlide = () => {
    setIndex((prev) => prev + 1);
    setTransitionEnabled(true);
  };

  // Prev slide (move by one) for infinite
  const prevSlide = () => {
    setIndex((prev) => prev - 1);
    setTransitionEnabled(true);
  };

  // Autoplay logic
  useEffect(() => {
    const startAutoplay = () => {
      stopAutoplay();
      autoplayRef.current = setInterval(() => {
        nextSlide();
      }, 2500);
    };
    const stopAutoplay = () => {
      if (autoplayRef.current) clearInterval(autoplayRef.current);
    };

    startAutoplay();
    return () => stopAutoplay();
    // eslint-disable-next-line
  }, [slidesToShow, clonedSlides]);

  // Infinite loop part ("jump" after moving to clone)
  useEffect(() => {
    if (!transitionEnabled) return;

    if (index === clonedSlides.length - slidesToShow) {
      // If reached the end clone, go back to "first real slide"
      const timer = setTimeout(() => {
        setTransitionEnabled(false);
        setIndex(slidesToShow);
      }, 400); // Duration must match the CSS transition
      return () => clearTimeout(timer);
    } else if (index === 0) {
      // If reached the start clone, go to "last real slide"
      const timer = setTimeout(() => {
        setTransitionEnabled(false);
        setIndex(clonedSlides.length - 2 * slidesToShow);
      }, 400);
      return () => clearTimeout(timer);
    }
  }, [index, clonedSlides, slidesToShow, transitionEnabled]);

  // Re-enable transitions after instant jump
  useEffect(() => {
    if (!transitionEnabled) {
      const timer = setTimeout(() => {
        setTransitionEnabled(true);
      }, 50);
      return () => clearTimeout(timer);
    }
  }, [transitionEnabled]);

  // Pause on hover
  const stopAutoplay = () => {
    if (autoplayRef.current) clearInterval(autoplayRef.current);
  };

  const startAutoplay = () => {
    stopAutoplay();
    autoplayRef.current = setInterval(nextSlide, 2500);
  };

  // Compute slide width and translateX
  const slideCount = clonedSlides.length;
  const cardWidthPercent = 100 / slideCount;
  const translatePercent = -(index * (100 / slideCount));

  return (
    <div className="bg-[#fff6f1] py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h4 className="text-4xl  main-heading-font-size   mb-6">
            Why Home Assistance?
          </h4>
        </div>
        <div className="relative overflow-hidden">
          {/* Left/Right Arrow Buttons */}
          <button
            aria-label="Previous"
            className="z-10 absolute left-2 top-1/2 -translate-y-1/2 w-10 h-10 bg-white rounded-full shadow flex items-center justify-center hover:bg-orange-100 transition"
            onClick={() => {
              prevSlide();
              stopAutoplay();
              startAutoplay();
            }}
            style={{ fontSize: "1.5rem" }}
          >
            <svg
              width="24"
              height="24"
              fill="none"
              stroke="#f59e42"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <polyline points="15 18 9 12 15 6" />
            </svg>
          </button>
          <button
            aria-label="Next"
            className="z-10 absolute right-2 top-1/2 -translate-y-1/2 w-10 h-10 bg-white rounded-full shadow flex items-center justify-center hover:bg-orange-100 transition"
            onClick={() => {
              nextSlide();
              stopAutoplay();
              startAutoplay();
            }}
            style={{ fontSize: "1.5rem" }}
          >
            <svg
              width="24"
              height="24"
              fill="none"
              stroke="#f59e42"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <polyline points="9 6 15 12 9 18" />
            </svg>
          </button>

          <div
            ref={sliderRef}
            className="flex"
            onMouseEnter={stopAutoplay}
            onMouseLeave={startAutoplay}
            style={{
              width: `${(slideCount * 100) / slidesToShow}%`,
              transform: `translateX(${translatePercent}%)`,
              transition: transitionEnabled
                ? "transform 0.4s cubic-bezier(.72,.16,.39,.95)"
                : "none",
            }}
          >
            {clonedSlides.map((service, i) => (
              <div
                key={i}
                className="flex-none px-2 sm:px-4"
                style={{
                  width: `${100 / slideCount}%`,
                }}
              >
                <div
                  className="bg-white rounded-xl shadow-[4px_8px_8px_0px_#e4e2e1] text-center h-48 sm:h-44 md:h-48 lg:h-52 my-4 mx-auto transition-transform hover:shadow-lg"
                  style={{ width: "90%", marginRight: "1rem" }}
                >
                  <div className="p-4">
                    <img
                      src={service?.icon}
                      alt={service?.title}
                      className="w-full h-16 object-contain mt-2"
                    />
                    <h6 className="text-lg sm:text-xl  font-['Poppins'] mb-2">
                      {service?.title}
                    </h6>
                    <p className="text-sm sm:text-base font-['Poppins'] text-gray-600">
                      {service?.descp}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhyHomeAssistance;
